<nb-card size="medium">
    <nb-card-header>
        <span *ngIf="edit">Labot klasifikatoru</span>
        <span *ngIf="!edit">Pievienot klasifikatoru</span>
    </nb-card-header>
    <nb-card-body>
        <div>
            <form (ngSubmit)="submitClassifier()" #form="ngForm" aria-labelledby="title">
                <div class="form-control-group">
                    <label class="label">Nosaukums</label>
                    <input
                        nbInput
                        [(ngModel)]="classifier.name"
                        #classifierName="ngModel"
                        name="classifierName"
                        fullWidth
                        [status]="classifierName.touched ? (classifierName.invalid ? 'danger' : 'success') : ''"
                        [required]="true"
                        [maxlength]="60"
                        [attr.aria-invalid]="classifierName.invalid && classifierName.touched ? true : null"
                    />
                    <ng-container *ngIf="classifierName.invalid && classifierName.touched">
                        <p class="error-message" *ngIf="classifierName.errors?.required">
                            Lauks ir obligāts!
                        </p>
                    </ng-container>
                </div>

                <div class="form-control-group">
                    <label class="label">Apraksts</label>
                    <textarea
                        nbInput
                        [(ngModel)]="classifier.description"
                        #classifierDescription="ngModel"
                        name="classifierDescription"
                        fullWidth
                        [status]="classifierDescription.touched ? (classifierDescription.invalid ? 'danger' : 'success') : ''"
                        [maxlength]="1000"
                    >
                    </textarea>
                </div>

                <nb-checkbox [(ngModel)]="classifier.enabled" name="active" id="active">
                    <span>Atļauts</span>
                </nb-checkbox>

                <button nbButton fullWidth status="success" class="mt-3" [disabled]="!form.valid">
                    Saglabāt
                </button>
            </form>
        </div>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton hero status="primary" (click)="dismiss()">Aizvērt</button>
    </nb-card-footer>
</nb-card>
